var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressbook1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2c0-.56.44-1 1-1h16c.55 0 1 .44 1 1v20c0 .55-.45 1-1 1H5c-.56 0-1-.45-1-1V2Zm2 1v18h14V3H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5h3v2H2V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11h3v2H2v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 17h3v2H2v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6c0-.56.44-1 1-1h9c.55 0 1 .44 1 1v4c0 .55-.45 1-1 1h-9c-.56 0-1-.45-1-1V6Zm2 1v2h7V7h-7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressbook1);
export default __webpack_public_path__ + "static/media/address book 1.15ac8c27ab150640d71bc028d339bab6.svg";
export { ForwardRef as ReactComponent };